import { observable, action } from 'mobx';
import { Account } from '@modules/core/models';

export class SelectedEntityState {
    @observable account: Account;
    @action selectAccount = (account: Account) => {
        if (this.account?.id === account?.id && this.account?.organization?.id === account?.organization?.id) {
            return;
        }
        this.account = account;
    };
}

export const selectedEntityState = new SelectedEntityState();
